import React from "react";

const PageAnchor = (props) => {

  const anchor = props.title.replace(/\s+/g, '-').toLowerCase();
  return (
    <div id={anchor} className="anchor-link"></div>
  )
}

export default PageAnchor;